import React, { useState } from 'react'
import { Collapse, List, Menu, useMediaQuery, useTheme } from '@mui/material'
import { StyledMenuItem, AccountDropdownButton, StyledChip } from './styles'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import { getPagePermissions } from '../../../store/slices/roleSlice/selectors'
import { StyledListItemButton, StyledListItemText } from '../MobileTabMenu/style'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useNavigate } from 'react-router-dom'
import ROUTES from '../../../consts/paths'
import { useSetupTour } from '../../../features/SetupWizardFeature/SetupWizardProvider'
import { wizardKeys } from '../../../features/SetupWizardFeature/constants'
import { useUserProfile } from '../../../hooks/useUserProfile'

const AccountDropdown: React.FC = () => {
  const handleHelpCenterClick = (): void => {
    window.open('https://classranked.helpscoutdocs.com/', '_blank')
  }
  const { data: userProfile } = useUserProfile()
  const user = userProfile?.user
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isOpenForMobile, setIsOpenForMobile] = useState<boolean>(false)
  const theme = useTheme()
  const pagePermissions = getPagePermissions()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { setIsLogoutConfirmationOpen } = useSetupTour()

  // NOTE: the "Surveys due" menu item and its badge are commented out below, in both the desktop
  // and mobile branches, and were before CR-293 touched this file. The client-side
  // `filter(...).length` that fed the badge has been removed rather than repointed, because
  // fetching the survey list to populate UI nobody renders would be a request for nothing.
  //
  // If the badge is ever re-enabled: take the count from
  // `useStudentDistributions(1, isStudent).actionableCount`, never from the rows. It is computed
  // server-side over the whole list, so it stays correct once the dashboard is paginated — a
  // client-side filter would silently become "due surveys on the first page".
  const isStudent = pagePermissions?.includes('Student Survey List - Page')

  const navigate = useNavigate()

  const handleSignOut = (): void => {
    if (localStorage.getItem(wizardKeys.localKey)) {
      setIsLogoutConfirmationOpen(true)
    } else {
      navigate(ROUTES.LOGOUT)
    }
  }

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = (): void => {
    setAnchorEl(null)
  }

  return (
    <>
      {!isMobile &&
        <>
          <AccountDropdownButton onClick={(e) => { handleOpenMenu(e) }} >
            {user?.firstName || 'Account'} <ExpandMoreRoundedIcon />
          </AccountDropdownButton>

          <Menu role='list' anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
            disableScrollLock
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            sx={{ mt: theme.spacing(2) }}
            slotProps={{
              paper: {
                style: {
                  padding: `${theme.spacing(2)} 0`
                }
              }
            }}
            MenuListProps={{
              style: {
                padding: 0,
                minWidth: theme.spacing(60),
                borderRadius: theme.spacing(2)
              }
            }}
            anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} elevation={3}>
            {/* {
              isStudent &&
              <StyledMenuItem onClick={() => {
                navigate(ROUTES.STUDENT_SURVEYS)
              }}>
                Surveys due
                {
                  surveyDues && surveyDues?.length > 0 &&
                  <StyledChip>{surveyDues?.length}</StyledChip>
                }
              </StyledMenuItem>
            } */}
            <StyledMenuItem onClick={handleHelpCenterClick}>
              Help Center
            </StyledMenuItem>
            <StyledMenuItem onClick={() => { handleSignOut() }}>
              Logout
            </StyledMenuItem>
          </Menu>
        </>
      }

      {isMobile &&
        <>
          <StyledListItemButton onClick={() => { setIsOpenForMobile(!isOpenForMobile) }} active={isOpenForMobile} >
            <StyledListItemText primary={user?.firstName || 'Account'} />
            {isOpenForMobile ? <ExpandLess /> : <ExpandMore />}
          </StyledListItemButton>
          <Collapse in={isOpenForMobile} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* {
                isStudent &&
                <StyledMenuItem >
                  Surveys due
                  <StyledChip>{surveyDues?.length}</StyledChip>
                </StyledMenuItem>
              } */}
              <StyledMenuItem onClick={handleHelpCenterClick}>
                Help Center
              </StyledMenuItem>
              <StyledMenuItem onClick={() => { handleSignOut() }} >
                Logout
              </StyledMenuItem>
            </List>
          </Collapse>
        </>
      }
    </>
  )
}

export default AccountDropdown
